<template>
  <div class="colorful-background wrapper-grid special">
    <div
      :class="['title', { animate__animated: isFirst }, ' animate__flipInX']"
    >
      <span class="small-font">
        您本学期成绩最好的课是
      </span>
      <span class="up-small-font">
        {{ select_score.Best.Class }}
      </span>
      <span>
        <span class="up-small-font">
          得分
        </span>
        <span class="big-font">
          {{ select_score.Best.Score }}
        </span>
      </span>
    </div>

    <div :class="['img', { animate__animated: isFirst }, 'animate__fadeIn']">
      <image-box img-u-r-l="/pic/4.png" side-position="right"></image-box>
    </div>

    <div
      :class="['text', { animate__animated: isFirst }, 'animate__fadeIn']"
      style="align-items: flex-end;"
    >
      <span class="up-small-font is-block special-GPA">本学期共选修了</span>
      <span class="middle-font is-block">{{ select_score.Credit }}学分</span>
      <span class="up-small-font is-block special-GPA">最终GPA为</span>
      <span class="middle-font is-block">{{
        select_score.GPA.toFixed(2)
      }}</span>
    </div>

    <div :class="['slogan', { animate__animated: isFirst }, 'animate__fadeIn']">
      <span class="small-font middle-margin-top">
        {{ sloganForShow }}
      </span>
    </div>

    <div class="footer middle-margin-bottom">
      <div class="very-small-font">
        成绩数据由杭电教务处提供,分析数据均在理想状态下计算
      </div>
      <span class="very-small-font">数据仅供参考，GPA请以教务处为准</span>
    </div>
  </div>
</template>

<script>
import store from '@/store/store'
import ImageBox from '@/components/utils/imageBox'
export default {
  name: 'bestScorePage',
  components: { ImageBox },
  data() {
    return {
      sloganForShow: '成绩不错,继续努力啊',
      sloganList: [
        '要继续加油啊！',
        '成绩不错，继续努力呀',
        '加油啊，能不能争取冲上4.0呢',
        '成绩很棒哦,来自小助手的认可',
        '这就是大佬么,让小助手膜拜一下',
      ],
    }
  },
  props: {
    isFirst: { type: Boolean, default: true },
  },
  computed: {
    select_score: function () {
      return store.state.$data.data.Select.Score
    },
  },
  mounted() {
    let GPA = this.select_score.GPA
    if (GPA < 3) {
      this.sloganForShow = this.sloganList[0]
    } else if (GPA < 3.7) {
      this.sloganForShow = this.sloganList[1]
    } else if (GPA < 4.0) {
      this.sloganForShow = this.sloganList[2]
    } else if (GPA < 4.5) {
      this.sloganForShow = this.sloganList[3]
    } else if (GPA >= 4.5) {
      this.sloganForShow = this.sloganList[4]
    } else {
      this.sloganForShow = this.sloganForShow[1]
    }
  },
}
</script>

<style scoped>
.img.animate__animated {
  animation-delay: var(--first-delay);
  animation-duration: var(--defalut-continue);
}

.title.animate__animated {
  animation-delay: var(--first-delay);
}

.text.animate__animated {
  animation-delay: var(--second-delay);
  animation-duration: var(--defalut-continue);
}

.slogan.animate__animated {
  animation-delay: var(--third-delay);
  animation-duration: var(--defalut-continue);
}

.wrapper-grid.special {
  --angle: 45deg;
  --first-color: var(--hduhelp-blue);
  --second-color: var(--eggplant-purple);
  --page-background-color: var(--hdu-school-blue);
  grid-template-rows: 5vh repeat(4, minmax(auto, auto)) 1fr 5vh;
  grid-template-areas:
    '. .      .'
    '. title  .'
    '. img    .'
    '. text   .'
    '. slogan .'
    '. .      .'
    '. footer .';
}
</style>
